import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ActiveFilter";
var classes = {
    details: "".concat(PREFIX, "-details"),
    filter: "".concat(PREFIX, "-filter"),
    filterValues: "".concat(PREFIX, "-filterValues"),
    filterType: "".concat(PREFIX, "-filterType"),
    closeButton: "".concat(PREFIX, "-closeButton")
};
var StyledActiveFilter = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(1, 2, 1, 2)
        },
        _b["& .".concat(classes.details)] = {
            display: "flex",
            width: "80%"
        },
        _b["& .".concat(classes.filter)] = {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(0, 0.5, 0, 0.5),
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        _b["& .".concat(classes.filterValues)] = {
            color: theme.palette.primary.main
        },
        _b["& .".concat(classes.filterType, "::first-letter")] = {
            textTransform: "uppercase"
        },
        _b["& .".concat(classes.closeButton)] = {
            alignSelf: "center",
            border: "none"
        },
        _b);
});

export { classes, StyledActiveFilter as default };
//# sourceMappingURL=index.styled.js.map
